import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion } from 'click-types';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'marginTop',
        'marginLeft',
        'borderRadius',
        'opacity',
        'height',
        'width',
      ]),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: attributes.backgroundColor || '#000',
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
      borderStyle:
        attributes.borderStyle === 'none' ? 'solid' : attributes.borderStyle,
      zIndex: attributes.zIndex,
      overflow: 'hidden',
      ...pick(attributes.style, ['opacity']),
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
          'margin',
          'marginTop',
          'marginLeft',
          'marginBottom',
          'marginRight',
        ])),
    },
  });
};

export default createStyles;
